import Canine, { HALF_WIDTH as CANINE_HW, NAME as CANINE_NAME } from './Canine';
import CentralIncisor, { HALF_WIDTH as CENTRAL_HW, NAME as CENTRAL_NAME } from './CentralIncisor';
import FirstMolar, { HALF_WIDTH as FIRST_MOLAR_HW, NAME as FIRST_MOLAR_NAME } from './FirstMolar';
import FirstPremolar, { HALF_WIDTH as FIRST_PREMOLAR_HW, NAME as FIRST_PREMOLAR_NAME } from './FirstPremolar';
import LateralIncisor, { HALF_WIDTH as LATERAL_HW, NAME as LATERAL_NAME } from './LateralIncisor';
import SecondMolar, { HALF_WIDTH as SECOND_MOLAR_HW, NAME as SECOND_MOLAR_NAME } from './SecondMolar';
import SecondPremolar, { HALF_WIDTH as SECOND_PREMOLAR_HW, NAME as SECOND_PREMOLAR_NAME } from './SecondPremolar';
import ThirdMolar, { HALF_WIDTH as THIRD_MOLAR_HW, NAME as THIRD_MOLAR_NAME } from './ThirdMolar';

export { CX, PAD, ROW_HEIGHT, VB_HEIGHT } from './frame';

export const UPPER_ROW = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
export const LOWER_ROW = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];
export const CHILD_UPPER_ROW = [55, 54, 53, 52, 51, 61, 62, 63, 64, 65];
export const CHILD_LOWER_ROW = [85, 84, 83, 82, 81, 71, 72, 73, 74, 75];
export const ALL_TEETH = [...UPPER_ROW, ...LOWER_ROW];

/* Keyed by the FDI position inside a quadrant (1 = central incisor … 8 = third molar). */
const TOOTH_TYPES = {
    1: { Component: CentralIncisor, halfWidth: CENTRAL_HW, name: CENTRAL_NAME },
    2: { Component: LateralIncisor, halfWidth: LATERAL_HW, name: LATERAL_NAME },
    3: { Component: Canine, halfWidth: CANINE_HW, name: CANINE_NAME },
    4: { Component: FirstPremolar, halfWidth: FIRST_PREMOLAR_HW, name: FIRST_PREMOLAR_NAME },
    5: { Component: SecondPremolar, halfWidth: SECOND_PREMOLAR_HW, name: SECOND_PREMOLAR_NAME },
    6: { Component: FirstMolar, halfWidth: FIRST_MOLAR_HW, name: FIRST_MOLAR_NAME },
    7: { Component: SecondMolar, halfWidth: SECOND_MOLAR_HW, name: SECOND_MOLAR_NAME },
    8: { Component: ThirdMolar, halfWidth: THIRD_MOLAR_HW, name: THIRD_MOLAR_NAME },
};

export function getToothDescriptor(fdi) {
    const tooth = Number(fdi);
    const quadrant = Math.floor(tooth / 10);
    const position = tooth % 10;
    const type = TOOTH_TYPES[position];

    if (!type) return null;

    const jaw = quadrant === 1 || quadrant === 2 || quadrant === 5 || quadrant === 6 ? 'upper' : 'lower';

    return {
        fdi: tooth,
        jaw,
        /* Quadrants 1 and 4 (and primary 5 / 8) are the mirror image of the authored shape. */
        isMirrored: quadrant === 1 || quadrant === 4 || quadrant === 5 || quadrant === 8,
        Component: type.Component,
        halfWidth: type.halfWidth[jaw],
        name: type.name[jaw],
    };
}

export function getToothName(fdi) {
    const descriptor = getToothDescriptor(fdi);
    if (!descriptor) return `Tish ${fdi}`;

    return `${descriptor.name} · ${descriptor.jaw === 'upper' ? 'yuqori' : 'pastki'} jag‘`;
}
